import React, { Component } from "react";

export default class Image extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.id || null,
      class: props.className || null,
      key: props.key || null,
      param: props.param || null,
      url: props.src || null,
      height: props.height || null,
      width: props.width || null,
      style: props.style || null,
      imageError: false,
      shape: props.shape || "circle",
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      id: nextProps.id || null,
      class: nextProps.className || null,
      key: nextProps.key || null,
      param: nextProps.param || null,
      url: nextProps.src || null,
      height: nextProps.height || null,
      width: nextProps.width || null,
      style: nextProps.style || null,
      shape: nextProps.shape || "circle",
      imageError: prevState.imageError,
    };
  }

  handleImageError = () => {
    this.setState({ imageError: true });
  };

  getColorFromInitial = initial => {
    // Generate a color based on the initial character
    const colors = [
      "#4CAF50",
      "#2196F3",
      "#9C27B0",
      "#F44336",
      "#FF9800",
      "#009688",
      "#673AB7",
      "#3F51B5",
    ];
    const charCode = initial.charCodeAt(0);
    return colors[charCode % colors.length];
  };

  createFallbackElement = () => {
    const { param, height, width, style, shape, class: className, id, key } = this.state;

    // Check if we have a valid param to work with
    if (!param || param.length === 0) {
      return (
        <div
          className={className}
          id={id}
          key={key}
          style={{
            ...style,
            display: "inline-block",
            height: height || "100%",
            width: width || "100%",
            backgroundColor: "#e0e0e0", // Light gray background
            borderRadius: shape === "rounded-square" ? "10px" : "50%",
          }}
        />
      );
    }

    // Get first character and generate background color
    const initial = param.charAt(0).toUpperCase();
    const backgroundColor = this.getColorFromInitial(initial);

    // Create the shaped element with the initial
    return (
      <div
        className={className}
        id={id}
        key={key}
        style={{
          ...style,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: height || "100%",
          width: width || "100%",
          backgroundColor,
          color: "#FFFFFF",
          fontWeight: "bold",
          fontSize: "1rem",
          borderRadius: shape === "rounded-square" ? "10px" : "50%",
        }}
      >
        {initial}
      </div>
    );
  };

  render() {
    const {
      url,
      imageError,
      id,
      class: className,
      key,
      height,
      width,
      style,
      shape,
      param,
    } = this.state;

    // Consistent container regardless of content
    return (
      <div
        className={className}
        id={id}
        key={key}
        style={{
          display: "inline-block",
          height: height || "100%",
          width: width || "100%",
          position: "relative",
          overflow: "hidden",
          borderRadius: shape === "rounded-square" ? "10px" : "50%",
          ...style,
        }}
      >
        {!url || imageError ? (
          // Fallback content
          param && param.length > 0 ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
                backgroundColor: this.getColorFromInitial(param.charAt(0)),
                color: "#FFFFFF",
                fontWeight: "500",
                fontSize: "1rem",
              }}
            >
              {param.charAt(0).toUpperCase()}
            </div>
          ) : (
            <div
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: "#e0e0e0",
              }}
            />
          )
        ) : (
          // Image content
          <img
            src={url}
            alt={param ? `Avatar for ${param}` : ""}
            onError={this.handleImageError}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        )}
      </div>
    );
  }
}
